const clone = (element: unknown) => JSON.parse(JSON.stringify(element));

function formatNumberWithCommas(value = "0.00") {
	if (!value) {
		return value;
	}
	const composed = value.split(".");

	if (!composed?.length) {
		return value;
	}

	composed[0] = composed?.[0]?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	return composed.join(".") || value;
}

const getExtension = (phone: string, check = false) => {
	if (!check) {
		return "";
	}
	const expression = /^(\d{3})(\d{3})(\d{4})(\d{5})$/.exec(phone);
	const extension = expression?.[4] ?? "";
	return extension ? ` Ext. ${extension}` : "";
};

/**
 * @description Format a phone number using the right country code.
 * @param phone String
 * @param hasExtension Boolean
 * @param country String
 * @returns String
 */
function formatPhoneNumber(phone: string, hasExtension = false, country = "USA") {
	if (phone && country === "USA") {
		phone = phone.replace(/\D/g, "");
		const expression = /^(\d{3})(\d{3})(\d{4})$/.exec(phone);
		const extension = getExtension(phone, hasExtension);

		if (expression) {
			const lastNumbers = 3;
			phone = `(${expression[1]}) ${expression[2]}-${expression[lastNumbers]}`;
			phone = `${phone}${extension}`.trim();
		}
	}
	return phone;
}

export { clone, formatNumberWithCommas, formatPhoneNumber };
